import React from "react";
import { Chip, makeStyles } from "@material-ui/core";
import { Check, GetApp } from "@material-ui/icons";
import fileDownload from "js-file-download";
import { useState } from "react";

const useStyles = makeStyles((theme) => ({
  chip: {
    marginTop: 5,
  },
}));

type DownloadChipProps = {
  fileName: string;
  getBlob: () => Promise<Blob>;
  onDelete?: (event: any) => void;
  disabled?: boolean;
};

export const DownloadChip: React.FC<DownloadChipProps> = ({
  fileName,
  getBlob,
  onDelete,
  disabled,
}) => {
  const classes = useStyles();
  const onClick = async () => {
    setState("DOWNLOADING");
    const blob = await getBlob();
    fileDownload(blob, fileName);
    setState("DOWNLOADED");
  };

  const [state, setState] = useState<
    "NOT_DOWNLOADED" | "DOWNLOADING" | "DOWNLOADED"
  >("NOT_DOWNLOADED");

  return (
    <Chip
      className={classes.chip}
      color="primary"
      label={fileName}
      onDelete={!disabled ? onDelete : undefined}
      onMouseDown={(event: any) => {
        event.stopPropagation();
      }}
      role="listitem"
      onClick={() => onClick()}
      icon={state === "DOWNLOADED" ? <Check /> : <GetApp />}
    />
  );
};
